// extracted by mini-css-extract-plugin
module.exports = {"container":"stats-chart_container__2DZsK","error":"stats-chart_error__27SUd"};